import Products from "components/common/products"

export default ({selection, loading}) => {
	return (
		<section>
			{ selection.products.items.length > 0
				? <Products products={selection.products.items} loading={loading}>
						{products => {
							if (products.length == 0) {
								return <p>Products is empty</p>
							}

							return (
								<ul>
									{ products.map(product => (
											<pre
												style={{
													marginBottom: "2rem",
													overflowX: "auto"
												}}
											>
												{JSON.stringify(product, null, 2)}
											</pre>
									))}
								</ul>
							)
						}}
					</Products>
				: <p>selection.products.items is empty</p>
			}
		</section>
	)
}
